import Zenscroll from 'zenscroll';

export default class Events {
    constructor(el, options) {
        this.el = el;
        this.options = options;

        this.bindUi();
        this.bindEventListener();
    }

    bindUi() {
        this.ui = {};
        this.ui.events = this.el.querySelectorAll('.event');
    }

    bindEventListener() {
        this.ui.events.forEach(item => {
            item.querySelectorAll('.wrapper')
                .forEach(el => el.addEventListener('click', () => this.showEventDetail(item)));
        });
    }

    showEventDetail($event) {
        Zenscroll.toY(this.getEventOffset($event));
        $event.classList.add('show');

        // wait one frame so element is at the top.
        /* window.requestAnimationFrame(() => {
            $event.classList.add('show');
        }); */
    }

    getEventOffset($event) {
        const rect = $event.getBoundingClientRect();
        const scrollTop = window.pageYOffset;
        const navBarHeight = document.querySelectorAll('.nav-bar')[0].clientHeight;
        return rect.top + scrollTop - navBarHeight - 7;
    }
}



// WEBPACK FOOTER //
// ./source/_assets/js/components/Events.js